<div class="menu-container" [ngClass]="{ 'mobile-menu': isMobile }">
    <div class="upper-menu">
        <ng-container *ngFor="let item of upperMenuItems">
            <ng-container *ngxPermissionsExcept="item.permissionsExcept">
                <ng-container *ngxPermissionsOnly="item.permissionsOnly">
                    <div
                        class="menu-item-wrapper"
                        [ngClass]="item.styleClassesString"
                        [routerLinkActive]="item.routerLinkActiveClass"
                        [routerLink]="item.navigation"
                        (click)="onNavigate(item.navigation)"
                    >
                        <ng-container *ngIf="item.nestedMenu; else normalItem">
                            <div #nestedMenuWrapper class="menu-item" (click)="item.nestedMenu(nestedMenuWrapper)">
                                <mat-icon class="menu-icon" [ngClass]="[item.icon]"></mat-icon>
                                <div class="item-label">{{ item.textLabel }}</div>
                            </div>
                        </ng-container>
                        <ng-template #normalItem>
                            <div class="menu-item">
                                <mat-icon class="menu-icon" [ngClass]="[item.icon]"></mat-icon>
                                <div class="item-label">
                                    {{ item.textLabel }}
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
    <!-- id is used to check height of this element in secondary nav -->
    <div id="mainNavLowerMenu" class="lower-menu">
        <ng-container *ngFor="let item of lowerMenuItems">
            <ng-container *ngxPermissionsExcept="item.permissionsExcept">
                <ng-container *ngxPermissionsOnly="item.permissionsOnly">
                    <div
                        class="menu-item-wrapper rounded-border-icon"
                        (click)="onNavigate(item.navigation)"
                        [ngClass]="{ tooltip: item.tooltip }"
                    >
                        <ng-container *ngIf="item.nestedMenu; else normalItem">
                            <div #nestedMenuWrapper class="menu-item" (click)="item.nestedMenu(nestedMenuWrapper)">
                                <mat-icon *ngIf="item?.tooltip.isAuthPanel; else icon"><img src="assets/images/vector.png" alt="sign out icon" /></mat-icon>
                                <ng-template #icon><mat-icon class="menu-icon" [ngClass]="[item.icon]"></mat-icon></ng-template>
                            </div>
                        </ng-container>
                        <ng-template #normalItem>
                            <div class="menu-item">
                                <mat-icon class="menu-icon" [ngClass]="[item.icon]"></mat-icon>
                            </div>
                        </ng-template>
                        <div
                            *ngIf="item?.tooltip"
                            class="tooltiptext"
                            [ngClass]="{ 'auth-tooltip': item?.tooltip.isAuthPanel, 'normal-tooltip': !item?.tooltip.isAuthPanel }"
                            (click)="(false); $event.stopPropagation()"
                        >
                            <div *ngIf="item?.tooltip.isAuthPanel; else normal">
                                <div class="email">
                                    {{ user?.email }}
                                </div>
                            </div>
                            <ng-template #normal
                                ><span>{{ item.tooltip.text }}</span></ng-template
                            >
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</div>

<ng-template #accountSearch>
    <div class="overlay-item overlay-top-item account-search" [ngClass]="{ 'mobile-menu-item': isMobile }">
        <div class="query-input">
            <input #searchInput class="search-input" matInput (keydown)="onSearchingEvents($event)" [(ngModel)]="queryString" />
            <div class="rounded-border-icon" fxFlex="0 1 auto">
                <mat-icon class="fp-icon-right" (click)="onSearchingEvents()"></mat-icon>
            </div>
        </div>
        <!-- later search filter implementation -->
        <!-- <div class="filter-checkbox-group">
            <div id="search-by">
                <strong>Search by</strong>
            </div>
            <div id="search-by-filter">
                <form [formGroup]="filterForm">
                    <div class="filter-row">
                        <div>
                            <mat-checkbox formControlName="firstOrLast" color="primary" class="checkbox">First, last name</mat-checkbox>
                        </div>
                        <div>
                            <mat-checkbox formControlName="address" color="primary" class="checkbox">Address</mat-checkbox>
                        </div>
                    </div>
                    <div class="filter-row">
                        <div>
                            <mat-checkbox formControlName="companyName" color="primary" class="checkbox">Company name</mat-checkbox>
                        </div>
                        <div>
                            <mat-checkbox formControlName="city" color="primary" class="checkbox">City</mat-checkbox>
                        </div>
                    </div>
                    <div class="filter-row">
                        <div>
                            <mat-checkbox formControlName="phone" color="primary" class="checkbox">Phone number</mat-checkbox>
                        </div>
                        <div>
                            <mat-checkbox formControlName="email" color="primary" class="checkbox">Email</mat-checkbox>
                        </div>
                    </div>
                    <div class="filter-row">
                        <div>
                            <mat-checkbox formControlName="accountNumber" color="primary" class="checkbox">Account number</mat-checkbox>
                        </div>
                        <div>
                            <mat-checkbox formControlName="uuid" color="primary" class="checkbox">UUID</mat-checkbox>
                        </div>
                    </div>
                </form>
            </div>
        </div> -->
    </div>
</ng-template>

<ng-template #authPanel>
    <div class="overlay-item overlay-bottom-item">
        <div class="useremail">
            {{ user?.email }}
        </div>
        <div class="log-out" (click)="logout()">Sign Out</div>
    </div>
</ng-template>
